module.exports = __webpack_public_path__ + "media/images/amenities_icons/arcade_game-bb6371c94f846d23390ad4805a323196.svg";